import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import DatePickerSF from '../../../widgets/input/DatePickerSF'
const SoaTxnDescUpdateModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  submitted, updateMode,
  // event handlers
  onSubmit, onCancelClick,
  //
  txnDate, onTxnDateChange, txnDateError, setTxnDateError,
  description, onDescriptionChange, descriptionError, setDescriptionError,
  dsraCurrent, onDsraCurrentChange, dsraCurrentError, setDsraCurrentError,
  dsraAmount, onDsraAmountChange, dsraAmountError, setDsraAmountError,
  osPrincipal, onOsPrincipalChange, osPrincipalError, setOsPrincipalError,
  osLoan, onOsLoanChange, osLoanError, setOsLoanError,
  osBalance, onOsBalanceChange, osBalanceError, setOsBalanceError,
  escrowBalance, onEscrowBalanceChange, escrowBalanceError, setEscrowBalanceError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update description'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <div className='g_flex_h'>
      <div className='g_flex_v'>
        <InputTextSF type='text' name='txnDate' label='Transaction Date'
          autoFocus={true} help='YYYY-MM-DD'
          value={txnDate} onChange={onTxnDateChange}
          error={txnDateError} setError={setTxnDateError}
        />
        <InputTextSF type='text' name='description' label='Description'
          required={true} autoFocus={true}
          value={description} onChange={onDescriptionChange}
          error={descriptionError} setError={setDescriptionError}
        />
      </div>
      <div className='g_flex_v'>
        <InputTextSF type='text' name='dsraCurrent' label='Dsra Current'
          autoFocus={true}
          value={dsraCurrent} onChange={onDsraCurrentChange}
          error={dsraCurrentError} setError={setDsraCurrentError}
        />
        <InputTextSF type='text' name='dsraAmount' label='Dsra Amount'
          value={dsraAmount} onChange={onDsraAmountChange}
          error={dsraAmountError} setError={setDsraAmountError}
        />
      </div>
    </div>
    <div className='g_flex_h'>
      <div className='g_flex_v'>
        <InputTextSF type='text' name='osPrincipal' label='OS Principal'
          value={osPrincipal} onChange={onOsPrincipalChange}
          error={osPrincipalError} setError={setOsPrincipalError}
        />
        <InputTextSF type='text' name='osLoan' label='OS Loan'
          value={osLoan} onChange={onOsLoanChange}
          error={osLoanError} setError={setOsLoanError}
        />
      </div>
      <div className='g_flex_v'>
        <InputTextSF type='text' name='osBalance' label='OS Balance'
          value={osBalance} onChange={onOsBalanceChange}
          error={osBalanceError} setError={setOsBalanceError}
        />
        <InputTextSF type='text' name='escrowBalance' label='Escrow Balance'
          value={escrowBalance} onChange={onEscrowBalanceChange}
          error={escrowBalanceError} setError={setEscrowBalanceError}
        />
      </div>
    </div>
  </ModalFormUI>

export default SoaTxnDescUpdateModalUI
